import { render, staticRenderFns } from "./RichHorizontalIndicator.vue?vue&type=template&id=04ec0f68&scoped=true&"
import script from "./RichHorizontalIndicator.vue?vue&type=script&lang=js&"
export * from "./RichHorizontalIndicator.vue?vue&type=script&lang=js&"
import style0 from "./RichHorizontalIndicator.vue?vue&type=style&index=0&id=04ec0f68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ec0f68",
  null
  
)

component.options.__file = "RichHorizontalIndicator.vue"
export default component.exports